const Form057TC = {
    stepName: {
        statement: "重要事項",
        information: "基本資料",
        check: "選擇甲/乙/丙/丁/戊部",
        sectionA: "甲部",
        sectionB: "乙部",
        sectionC: "丙部",
        sectionD: "丁部",
        sectionE: "戊部",
        certify: "聲明",
        confirmation: "確認",
    },
    errorMsg: {
        date: {
            afterThisDate: "請在{{name}} {{targetDate}} 之後選擇日期",
            beforeThisDate: "請在{{name}} {{targetDate}} 之前選擇日期",
            laterThanDate: "日期不得晚于本學科學年的8月31日",
        },
        schLeave: "學校部 = 休假時間 >= 1天",
        bdgLeave: "宿舍部 = 休假時間 > 2天",
    },
    label: {
        notes: "備註",
        terms: "聲明",
        agree: "申請人應仔細閱讀並同意",
        data: "關於隱私數據的註釋",
        read: "本人已閱讀，明白及同意上述條款及細則",
        schoolInfor: "學校資料",
        schoolName: "學校名稱",
        schoolCode: "學校代碼",
        month: "月份",
        year: "年份",
        example: "例如：",
        assuming:
            "假設合資格申領「津貼」的時期是由2月5日至5月26日，計算合資格月數的方法如下：",
        claimSNG: "申領表格選擇",
        selectSNG: "請選擇",
        claim: "新／修訂",
        post: "職位",
        section: "部門",
        periodFrom: "開始時間",
        periodTo: "結束時間",
        leavePeriodFrom: "休假開始時間",
        leavePeriodTo: "休假結束時間",
        calendar: "曆日數目",
        a: "工作日數",
        b: "日薪率",
        workingDay: "工作日數",
        dailyRate: "日薪率",
        c: "合資格月數",
        d: "月薪",
        e: "強積金供款津貼",
        subsidy: "強積金供款津貼",
        f: "「津貼」金額",
        salaryAmount: "薪金",
        totalSNG: "總額（「津貼」金額）",
        attached:
            "新：新申領津貼的職位／修訂：修訂的申領（隨附（前次日期）的申領表格副本）。",
        attachedTitle: "所附日期爲以前索賠的副本",
        remark: "備註",
        indicate: "請註明以下文件",
        leaveInfor: "休假護士的資料",
        sngInfor: "「津貼」的資料",
        name: "姓名",
        SPN: "職員參考編號",
        reason: "缺勤原因",
        claimDailyRated: "本人欲申領發還日薪代職護士薪金，詳情如下：",
        supplyInfo: "代職護士的資料",
        supplyName: "代職護士姓名",
        supplyFrom: "代職開始時間",
        supplyTo: "代職結束時間",
        salaryTotal: "總額（薪金）",
        staffNumber: "職員編號",
        contractFrom: "合約開始時間",
        contractTo: "合約結束時間",
        salarySubTotal: "小計（薪金）",
        subsidySubTotal: "小計（強積金供款）",
        allTotal: "總額（薪金+強積金供款）",
        certify: "本人證實：",
        emoluments: "有關薪酬已付予",
        needCheck: "您需要至少選擇一個選項",
        leave: "休假時期",
        vacancyPeriod: "空缺期",
        previousClaimDated: "隨附（前次日期）的申領表格副本",
        attachment: "附件",
        MPFAttachment: "強積金供款副本",
        postNumber: "職位數量",
        dailyRateAttachment: "就聘用日薪代職護士申領發還薪金收據副本",
        previousClaim: "本學年已提交之申請表格",
        previousClaimNumber: "請註明前次申領表格編號",
        MPFInformation: "強積金供款證明資料",
        from: "由",
        to: "至",
        postNo: "職位數量",
        applicationNo: "申請編號",
        adminType: "校監／校長",
        adminName: "校監／校長姓名",
        date: "日期",
        contactPerson: "聯絡人",
        telNo: "電話號碼",
        sSDO: "高級學校發展主任",
        ssdo1: "副本送：",
        ssdo2: "高級學校發展主任（",
        ssdo3: "）",
        subventions: "致：教育局經常津貼組",
        attn: "[經辦人：一級會計主任（經常津貼）]",
        certify1: "本人證實 –",
        and: "及",
        name1: "",
        name2: "姓名",
    },
    secValue: {
        sch: "學校部",
        bdg: "宿舍部",
    },
    previousClaimValue: {
        unchange: "不更改前次申領表格",
        delete: "刪除前次申領表格",
        change: "更改前次申領表格",
    },
    supplyValue: {
        nurse: "日薪代職護士",
        trustees: "強積金計劃的受託人",
    },
    sectionStep: {
        SectionA: "甲部",
        SectionB: "乙部",
        SectionC: "丙部",
        SectionD: "丁部",
        SectionE: "戊部",
    },
    sectionValue: {
        SectionA: "甲部 以護士長空缺職位換取「津貼」",
        SectionB: "乙部 以註冊護士空缺職位換取「津貼」",
        SectionC: "丙部 以「津貼」代替護士放取核准假期的臨時補缺人員安排",
        SectionD: "丁部 (日薪代職護士薪金) 僱主無須向強積金計劃供款",
        SectionE:
            "戊部 (日薪代職護士薪金) 僱主須向強積金計劃供款（代職期須連續60天或以上）",
    },
    leaveValue: {
        vacancy: "少於30天的休假時期",
        revocable: "不少於30天的休假時期",
    },
    vacancyValue: {
        vacancy: "少於30天的空缺期",
        revocable: "不少於30天而可撤回的空缺凍結期",
    },
    claimValue: {
        N: "新申領津貼的職位",
        R: "修訂的申領",
    },
    postValue: {
        NO: "護士長",
        RN: "註冊護士",
        EN: "登記護士",
    },
    adminValue: {
        supervisor: "校監",
        schoolHead: "校長",
    },
    sSDOValue: {
        0: "北區",
        1: "葵青區",
        2: "西貢區",
        3: "東區",
        4: "屯門區",
        5: "九龍城區",
        6: "觀塘區",
        7: "南區",
        8: "油尖旺區",
        9: "荃灣區",
        10: "沙田區",
        11: "深水埗區",
        12: "大埔區",
        13: "灣仔區",
        14: "離島區",
        15: "中西區",
        16: "元朗區",
        17: "黃大仙區",
    },
    noteList: [
        {
            text: "填寫‘√’號以表示護士空缺職位／休假護士屬於學校部或宿舍部。\n如申領津貼／薪金的職位屬於學校部及寄宿部，請“增加”附加部分並填寫相應信息。",
        },
        {
            text: "工作日數不應包括學校部或宿舍部假期、公眾假期、由學校自行訂定的假期或護士無須執行職務的任何周日。",
        },
        {
            text: "有關資助學校代職人員當前適用的日薪率，請參閱相關的教育局通函。為（i）填補少於30天的護士長及註冊護士的凍結職位；或（ii）放取少於30天核准假期的護士長或註冊護士（包括具精神科護理訓練的註冊護士）安排臨時補缺人員的代職護士津貼金額，以註冊護士代職人員的日薪率計算。為申領發還日薪代職護士薪金，護士長及註冊護士的代職薪金以註冊護士代職人員的日薪率計算。",
        },
        {
            text: "計算由起始日直至完結日（首尾兩天包括在內）的合資格申領「津貼」的月數，包含以下3個元素：",
        },
        {
            text: "",
        },
        {
            text: "如合資格申領期達60天或以上，強積金計劃僱主供款（月薪的5%，並以現行強積金規例所訂的最高金額為上限）將會包括在內。如換取現金津貼的護士空缺凍結期或護士放取核准假期的臨時補缺期少於60個曆日，而須向強積金供款，請提供證明資料。",
        },
        {
            text: "填寫休假護士的職員參考編號。",
        },
        {
            text: "請注意，學校必須按照《資助則例》、《學校行政手冊》的相關條文及教育局通告第1／2006號、第16／2015號（侍產假適用）以及第16／2018號（產假適用）的規定批假。",
        },
    ],
    five: [
        {
            text: "填寫護士長職位的起薪點，即總薪級表第26點的金額；",
        },
        {
            text: "填寫註冊護士職位的中點薪金，即總薪級表第20點的金額；",
        },
        {
            text: "填寫登記護士職位的中點薪金，即總薪級表第15點的金額",
        },
    ],
    calculate: [
        {
            text: "合資格日數在起始月份的曆日總數中所佔的比例（如適用）；",
        },
        {
            text: "完整的曆月數（如適用）；以及",
        },
        {
            text: "合資格日數在完結月份曆日總數中所佔的比例（如適用）。",
        },
    ],
    exampleList: [
        {
            text: "起始月份的合資格日數為24日（2月5日至2月28日）除以28日（2月份的曆日總數）=0.857個月；",
        },
        {
            text: "由3月至4月有兩個完整的曆月數；",
        },
        {
            text: "完結月份的合資格日數為26日（5月1日至26日）除以31日（五月份的曆日總數）=0.839個月；以及",
        },
        {
            text: "合資格申領月數應為上述3個元素的總和（計算至3個小數位），即0.857+2+0.839=3.696。",
        },
    ],
    termList: [
        {
            text: "（就聘用日薪代職護士申領發還薪金）有關薪酬已付予",
        },
        {
            text: "隨附有關收據，以供記錄存檔；",
        },
        {
            text: "本校已獲校董會／法團校董會及大多數護士同意，在本學年上述期間凍結甲部及乙部所載的護士職位；",
        },
        {
            text: "凍結甲部及乙部所載的護士職位並申領「津貼」，是因為該（等）核准編制的職位在上述期間有空缺及此項申領符合「津貼」所列明的申領條件；以及",
        },
        {
            text: "本校沒有就甲部至戊部所列的假期／空缺向政府申領其他津貼。",
        },
        {
            text: "本校會把任何多收取的津貼退還教育局。",
        },
    ],
    symbolList: [
        {
            text: "（i）",
        },
        {
            text: "（ii）",
        },
        {
            text: "（iii）",
        },
        {
            text: "（iv）",
        },
    ],
    // statementList: [
    //     {
    //         text: "請提交電子表格或紙質表格，請注意，如果提交了重複的申請，處理過程可能會受影響。",
    //     },
    //     {
    //         text: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向有關高級學校發展主任提出",
    //     },
    // ],
    importantNotes: {
        p_title: "個人資料收集聲明",
        p1_1: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途︰",
        p1_a: "辦理與聘用有關的事宜；",
        p1_b: "處理發放薪金津貼，以及計算公積金的供款和贈款；",
        p1_c: "進行核數工作；",
        p1_d: "進行研究及統計資料，以便規劃教育服務；",
        p1_e: "處理有關教育專業人員發展的事宜；",
        p1_f: "執行《教育條例》、《教育規例》及附屬《補助/津貼學校公積金規則》(第279章)。",

        p2: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
        p3: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局/部門/機構披露作上述用途。",
        p4: "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
        p5: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向教育局提出。",
    },
};
export default Form057TC;
